import script from "./ResultadosAdminView.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultadosAdminView.vue?vue&type=script&setup=true&lang=js"

import "./ResultadosAdminView.vue?vue&type=style&index=0&id=0980803a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0980803a"]])

export default __exports__